<template>
  <div class="upload-wrp">
    <div class="upload-box">
      <div class="upload-title">上传图片</div>
      <van-uploader v-model="fileList" :after-read="afterRead" :multiple="isIOS()" :max-count="4"></van-uploader>
      <div class="upload-des">
        <div class="upload-des-title">上传要求：</div>
        <ul class="upload-des-list" v-for="(item, index) in uploadDes" :key="index">
          <li>{{ index + 1 }}、{{ item }}；</li>
        </ul>
      </div>
    </div>
    <div class="footer-bar">
      <van-button class="submit-button" @click="submit" type="primary" block>提交</van-button>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { Dialog } from '@vant/compat'
import { uploadApi } from '@/api/upload'
import { uploadGroupScreenshotApi } from '@/api/brisk'
import { uploadStyleEnum } from '@/enum/uploadEnum'
import { isIOS } from '@/utils/is'
import usePage from '@/hooks/usePage'
import { useUserStore } from '@/store/user'

const userStore = useUserStore()
const projectInfo = userStore.getProjectInfo
const { navigateBack } = usePage()
const uploadDes = ['100人的群，截图群成员信息', '截图清晰，需要包含头像', '最多可上传四张图片']
const fileList = ref([])

const afterRead = async file => {
  let files = file.length ? file : [file]
  for (let i = 0; i < files.length; i++) {
    const item = files[i]
    item.status = 'uploading'
    item.message = '上传中...'
    const resData = await uploadApi({ file: item.file, style: uploadStyleEnum.STYLE_PIC_STD })
    item.status = resData ? 'success' : 'failed'
    item.message = resData ? '上传成功' : '上传失败'
    item.content = resData ? resData.file_url.url : ''
  }
}

const submit = async () => {
  const resData = await uploadGroupScreenshotApi({ content: fileList.value.map(d => d.content) })
  if (resData) {
    Dialog.alert({
      title: '上传成功',
      message: `审核通过后可获得${resData.brisk}${projectInfo.integralName}～`
    }).then(() => {
      navigateBack({ refresh: true }, '/brisk/briskGroupPicCheckStatus')
    })
  }
}
</script>
<style lang="less" scoped>
.upload-wrp {
  padding: 12px;
}
.upload-box {
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  .upload-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .upload-des {
    font-size: 12px;
    color: #999;
    .upload-des-title {
      margin-bottom: 5px;
      margin-top: 15px;
    }
  }
}
.footer-bar {
  position: fixed;
  padding: 12px;
  background-color: #fff;
  width: 100%;
  left: 0;
  bottom: 0;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
}
.submit-button {
  height: 40px;
}
// .check-fail-wrp {
//   background-color: #fff;
//   padding: 0 50px;
//   height: 100%;
//   .check-fail-box {
//     text-align: center;
//     margin: auto;
//     padding: 100px 0;
//     .check-status {
//       font-weight: 500;
//       line-height: 28px;
//       font-size: 20px;
//       margin-top: 20px;
//       margin-bottom: 8px;
//     }
//     .check-status-des {
//       font-size: 14px;
//       color: #999;
//     }
//   }
//   .submit-button {
//     margin-top: 40px;
//   }
// }
</style>
